import 'bootstrap-datetime-picker/css/bootstrap-datetimepicker.min.css';
import moment from 'moment';
import 'bootstrap-datetime-picker/js/bootstrap-datetimepicker.min';
import 'bootstrap-datetime-picker/js/locales/bootstrap-datetimepicker.pt-BR';

export function setDatetimePicker(cssSelector, onChangeDate) {
    let options = {
        format: "dd/mm/yyyy hh:ii",
        autoclose: true,
        todayBtn: false,
        clearBtn: true,
        pickerPosition: "bottom-left",
        language: 'pt-BR',
    };

    let dtp = $(cssSelector).datetimepicker(options);

    dtp.on('changeDate', (ev) => {
        let date = ev.date ? ev.date.valueOf() : null;
        let text = date ? moment(date).format('DD/MM/YYYY HH:mm') : 'não especificado';
        let query = date ? moment(date).format('YYYY-MM-DD HH:mm') : null;
        onChangeDate({ date, text, query });
    });
}



// WEBPACK FOOTER //
// src/views/controls/DatetimePicker.js